"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSizes = exports.getRotates = exports.getFlips = exports.getCountryCodes = exports.getCountries = void 0;

var _enums = require("../static/enums");

var getCountries = function getCountries() {
  return _enums.countries;
};

exports.getCountries = getCountries;

var getCountryCodes = function getCountryCodes() {
  return _enums.countries.map(function (country) {
    return country.code;
  });
};

exports.getCountryCodes = getCountryCodes;

var getFlips = function getFlips() {
  return _enums.flips;
};

exports.getFlips = getFlips;

var getRotates = function getRotates() {
  return _enums.rotates;
};

exports.getRotates = getRotates;

var getSizes = function getSizes() {
  return _enums.sizes;
};

exports.getSizes = getSizes;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/props.js
// module id = 99
// module chunks = 168707334958949